<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar"></navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="#pablo">{{ userType }}</a>
    </div>
     <template slot="navbar-menu">
      <!-- <form>
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split"></i>
            </div>
          </div>
        </div>
      </form> -->
      <ul class="navbar-nav">
         <drop-down icon="nc-icon nc-bell-55" tag="li" position="right" direction="none" class="nav-item dropdown">
            <a slot="title" slot-scope="{isOpen}" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="isOpen">
              {{ selectedLanguage }}
            </a>
            <a v-for="lang in langauges" :key="lang.id" v-show="lang.status" class="dropdown-item btn-rotate" @click.prevent="switchLanguage(lang.name)" href="#">
              {{ lang.name }}
            </a>
         </drop-down>
      </ul>
    </template>

    <template slot="navbar-menu">
      <!-- <form>
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split"></i>
            </div>
          </div>
        </div>
      </form> -->
      <ul class="navbar-nav">
        <!-- <li class="nav-item">
          <a class="nav-link btn-magnify" href="#pablo">
            <i class="nc-icon nc-layout-11"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li> -->
        <drop-down icon="nc-icon nc-bell-55" tag="li" position="right" direction="none" class="nav-item dropdown">
          <a slot="title" slot-scope="{isOpen}" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="isOpen">
            {{ authUser.name }} <img :src="'/static/img/faces/face-1.jpg'" class="img" style="border-radius:50%; margin-right:5px" width="30px" height="30px" alt="Pro">
          </a>
          <a class="dropdown-item btn-rotate" @click.prevent="handleModal()" href="#">
            <i class="fa fa-user"></i>
           {{ $t('view_profile') }}
          </a>
          <a class="dropdown-item btn-rotate" @click.prevent="openPassModal()" href="#">
            <i class="fa fa-refresh"></i>
            {{ $t('change_password') }}
          </a>
          <a class="dropdown-item btn-rotate" @click.prevent="logout()" href="#">
            <i class="fa fa-power-off" style="color:red"></i>
            {{ $t('logout') }}
          </a>
        </drop-down>
        <!-- <li class="nav-item">
          <a class="nav-link btn-rotate" href="#pablo">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li> -->
      </ul>
    </template>

    <!-- View Profile Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">
        {{ $t('user_profile') }}
      </h4>
      <ValidationObserver ref="userForm">
        <form>
          <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.name" :placeholder="$t('name')" :label="$t('name')"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="surname" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.surname" :placeholder="$t('surname')" :label="$t('surname')"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="email" rules="required|email|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.email" :placeholder="$t('email')" :label="$t('email')"></fg-input>
          </ValidationProvider>

        </form>
      </ValidationObserver>
      <template slot="footer">
        <!-- <div class="left-side">
          <p-button type="danger" link>Cancel</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link>Update</p-button>
        </div> -->
      </template>
    </modal>

    <!-- Change User Password -->
    <modal :show.sync="modals.pass" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">
       {{ $t('change_password')}}
      </h4>
      <ValidationObserver v-show="showCodeForm">
        <form>
          <ValidationProvider name="email" rules="required|email|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.email" :placeholder="$t('email_address')" :label="$t('email_address')" disabled></fg-input>
          </ValidationProvider>
          <p-button class="btn badge-primary text-white" type="primary" @click.prevent="sendResetCode()" link>{{ $t('send_password_reset_code') }}</p-button>
        </form>
      </ValidationObserver>

       <ValidationObserver v-if="showPasswordForm">
        <form>
          <ValidationProvider name="code" rules="required|min:3" v-slot="{ errors }">
            <label>{{ $t('reset_code') }}</label>
            <fg-input addon-left-icon="nc-icon nc-single-02" :error="errors[0]" v-model="form.code" placeholder="Code"></fg-input>
          </ValidationProvider>

           <ValidationProvider name="password" rules="required|min:6" v-slot="{ errors }">
            <label>{{ $t('password') }}</label>
            <fg-input :error="errors[0]" v-model="form.password"
              addon-left-icon="nc-icon nc-key-25" :placeholder="$t('password')" type="password"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="password_confirmation" rules="required|min:6|confirmed:password" v-slot="{ errors }">
            <label>{{ $t('confirm_password') }}</label>
            <fg-input :error="errors[0]" v-model="form.password_confirmation"
              addon-left-icon="nc-icon nc-key-25"
              :placeholder="$t('confirm_password')"
              type="password"></fg-input>
          </ValidationProvider>

        </form>
      </ValidationObserver>

      <template v-if="showPasswordForm" slot="footer" >
        <div class="left-side">
          <p-button type="danger" link @click.prevent="closeModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link @click.prevent="setUserPassword()">{{ $t('reset_password') }}</p-button>
        </div>
      </template>
    </modal>


  </navbar>


</template>
<script>
  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents';
  import Modal from "src/components/UIComponents/Modal.vue";
  import Langauges from "@/util/languages.js";
  import Resource from "@/util/Api/resource.js";
  const LangaugeList = new Langauges();
  const setPassResource = new Resource("auth/submit/passwordSet");
  const sendCodeResource = new Resource("auth/request/passwordSet");

  export default {
    components: {
      Navbar,
      NavbarToggleButton,
      Modal,
    },
    data() {
      return {
        langauges:[],
        selectedLanguage:'English',
        activeNotifications: false,
        showNavbar: false,
        userType: localStorage.getItem("userType"),
        user: localStorage.getItem("user"),
        authUser:{},
        showPasswordForm:false,
        showCodeForm: true,
        modals: {
          classic: false,
          pass:false,
        },
        form:{
          userID:'',
          name:'',
          surname:'',
          email:'',
          code:'',
          password:'',
          password_confirmation:'',
        },

      }
    },
    created() {
      this.authUser =  JSON.parse(this.user);
      this.selectedLanguage = this.authUser[0].languageName ? this.authUser[0].languageName : 'English';
      this.langauges = LangaugeList.getAll();

      this.switchLanguage( this.selectedLanguage );
    },

    methods: {
      switchLanguage( langName ){
        this.langauges.forEach( lang => {
          if( lang.name.toLowerCase() === langName.toLowerCase()){
            this.selectedLanguage = langName;
            this.$i18n.locale = lang.code;
          }
        });
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },

      // functionality to logout
      logout(){
        this.$store
        .dispatch("user/logout")
        .then(() => {
          localStorage.clear();
          this.$router.push({ path: "/login" });
        }).catch(error => {
          console.log("Login Errors :", error);
        });
      },

      // show profile modal
      handleModal() {
         let auth =  JSON.parse(this.user);
         this.form.userID = auth[0].id;
         this.form.name = auth[0].name;
         this.form.surname = auth[0].surname;
         this.form.email = auth[0].email;
         this.modals.classic = true;
      },

      // show change password modal
      openPassModal() {
         this.showPasswordForm = false;
         this.showCodeForm = true;
         let auth = JSON.parse(this.user);
         this.form.userID = auth[0].id;
         this.form.email = auth[0].email;
         this.modals.pass = true;
      },

      // sending password reset code to email
      async sendResetCode(){
          let formData = new FormData();
          formData.append("email", this.form.email);

          await sendCodeResource.store(formData)
          .then((response) => {
            if(response.data.success === true) {
               this.showAlertMessage(this.$("Password_reset_code_send_to_your_email"), "success");
               this.showPasswordForm = true;
               this.showCodeForm = false;
            } else {
               this.showAlertMessage(this.$t("email_does_not_exist"), "error");
            }
          }).catch(() => {})
      },

      // seting user password method
      async setUserPassword(){
       let formData = new FormData();
       formData.append("emailVerificationCode", this.form.code);
       formData.append("password", this.form.password);

       await setPassResource.store(formData)
       .then((response) => {
          if(response.data.result === 'thisUserIsNotRegognized') {
             this.showAlertMessage(this.$t("password_code_is_incorrect"), "error");
          } else if (response.data.result === true) {
             this.closeModal();
             this.showAlertMessage(this.$t("password_reset_successfully"), "success");
          }
       }).catch((error) => {
          console.log('error', error);
       });
    },

    // Message alert
    showAlertMessage(message, type) {
        this.$message.closeAll();
        this.$message({
          type: type,
          message: message
        });
    },

    // close modal
    closeModal() {
      this.modals.classic = false;
      this.modals.pass = false;
    },

    }
  }

</script>
<style>

</style>
